import { memo, useContext } from 'react';
import { VStack, Collapsible } from '@library';
import StoryblokRender from '../../../content/components/StoryblokRender';
import type { FooterSectionComponent } from '../../../content/types/types';
import { AppContext } from '../../context';
import commonStyles from './Footer.module.scss';
import styles from './FooterSection.module.css';

const FooterSection = ({ section }: { section: FooterSectionComponent }) => {
    const { isInMobileView } = useContext(AppContext);

    if (isInMobileView) {
        return (
            <Collapsible
                borderType="topBottom"
                trigger={
                    <div className={commonStyles.padded}>{section.title}</div>
                }
            >
                <div className={commonStyles.padded}>
                    <VStack gap="small">
                        <StoryblokRender
                            components={
                                section.links_v2 && section.links_v2.length
                                    ? section.links_v2
                                    : section.links
                            }
                            styles={{
                                link: styles.sectionLink,
                                linkText: styles.sectionLinkText,
                            }}
                        />
                    </VStack>
                </div>
            </Collapsible>
        );
    }

    return (
        <VStack gap="small" key={section.title}>
            <div className={styles.linkColumnTitle}>{section.title}</div>

            <VStack gap="mini">
                <StoryblokRender
                    components={
                        section.links_v2 && section.links_v2.length
                            ? section.links_v2
                            : section.links
                    }
                    styles={{
                        link: commonStyles.footerLink,
                    }}
                />
            </VStack>
        </VStack>
    );
};

export default memo(FooterSection);
